var render = function render(_c,_vm){return _c('div',{style:({width: _vm.props.widthRem + 'rem', height: _vm.props.widthRem + 'rem'})},[_c('div',{staticClass:"spinner-scaleout"})])
}
var staticRenderFns = []

export { render, staticRenderFns }